/**
 * Per-tip dismiss keys persisted via GET/PATCH /api/users/guides.
 * Each tip must use its own id so dismissing one does not hide another.
 */
export const GUIDE_IDS = {
  /** Creative preview → Actions (⋮) button intro for Email rewriter */
  CREATIVE_PREVIEW_EMAIL_REWRITER: "creative-preview-email-rewriter",
  /** Creative preview → first open of Actions menu → Rewrite email item */
  ACTIONS_MENU_REWRITE_EMAIL: "actions-menu-rewrite-email",
} as const;

export type GuideId = (typeof GUIDE_IDS)[keyof typeof GUIDE_IDS];
